//src/app/features/profile/businessDetails/addBusinessDetails/formFields.ts
import { Validators } from 'utils/Validators';
import * as Yup from 'yup';

export const getFormationYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [
    { label: `Before ${currentYear}`, value: `Before ${currentYear}` },
    { label: `After ${currentYear}`, value: `After ${currentYear}` },
  ];
};

export const FillingTypeOptions = [
  { label: 'Initial Report', value: 'Initial Report' },
  { label: 'Correct Prior Report', value: 'Correct Prior Report' },
  { label: 'Correct Current Report', value: 'Correct Current Report' },
  { label: 'Newly Exempt Entity', value: 'Newly Exempt Entity' },
];

export const TaxIdentificationOptions = [
  { label: 'EIN', value: 'EIN' },
  { label: 'SSN/ITIN', value: 'SSN/ITIN' },
  { label: 'Foreign', value: 'Foreign' },
];

export const IndustryOptions = [
  { label: 'Agriculture', value: 'Agriculture' },
  { label: 'Animal Services', value: 'Animal Services' },
  { label: 'Apparel', value: 'Apparel' },
  { label: 'Automotive', value: 'Automotive' },
  { label: 'Banking', value: 'Banking' },
  { label: 'Business', value: 'Business' },
  { label: 'Communications', value: 'Communications' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Concrete, Tile, Masonry', value: 'Concrete, Tile, Masonry' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'Cryptocurrency', value: 'Cryptocurrency' },
  { label: 'E-Commerce', value: 'E-Commerce' },
  { label: 'Education', value: 'Education' },
  { label: 'Electronics', value: 'Electronics' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'Entertainment', value: 'Entertainment' },
  { label: 'Environmental', value: 'Environmental' },

  { label: 'Finance', value: 'Finance' },
  { label: 'Food & Beverage', value: 'Food & Beverage' },
  { label: 'General Construction', value: 'General Construction' },
  { label: 'Government', value: 'Government' },
  { label: 'Health & Beauty', value: 'Health & Beauty' },
  { label: 'Healthcare', value: 'Healthcare' },
  { label: 'Hospitality', value: 'Hospitality' },
  { label: 'HVAC', value: 'HVAC' },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'Landscaping', value: 'Landscaping' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Machinery', value: 'Machinery' },
  {
    label: 'Marketing - Printing, Publishing',
    value: 'Marketing - Printing, Publishing',
  },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Media', value: 'Media' },
  { label: 'Not for Profit', value: 'Not for Profit' },
  { label: 'Publishing', value: 'Publishing' },
  { label: 'Real Estate', value: 'Real Estate' },
  { label: 'Recreation', value: 'Recreation' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Sales & Marketing', value: 'Sales & Marketing' },
  { label: 'Shipping', value: 'Shipping' },
  { label: 'Software and Internet', value: 'Software and Internet' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Telecommunications', value: 'Telecommunications' },
  { label: 'Transportation', value: 'Transportation' },
  {
    label: 'Travel Recreation and Leisure',
    value: 'Travel Recreation and Leisure',
  },
  { label: 'Utilities', value: 'Utilities' },

  { label: 'Veterinary Services', value: 'Veterinary Services' },
  { label: 'Wholesale and Distribution', value: 'Wholesale and Distribution' },
  { label: 'Other', value: 'Other' },
];

export const BusinessTypesOptions = [
  { label: 'C Corporation', value: 'C Corporation' },
  { label: 'S Corporation', value: 'S Corporation' },
  { label: 'Partnership', value: 'Partnership' },
  { label: 'LLC taxed as Partnership', value: 'LLC taxed as Partnership' },
  {
    label: 'LLC taxed as Sole Proprietorship',
    value: 'LLC taxed as Sale Proprietorship',
  },
  { label: 'Sole Proprietorship', value: 'Sale Proprietorship' },
  { label: 'LLC taxed as C Corp', value: 'LLC taxed as C Corp' },
  { label: 'LLC taxed as S Corp', value: 'LLC taxed as S Corp' },
  { label: 'Non Profit', value: 'Non Profit' },
];

export const OwenrshipOptions = [
  { label: 'Individual', value: 'individual' },
  { label: 'Estate', value: 'estate' },
  { label: 'Trust', value: 'trust' },
  { label: 'Exempt Organization', value: 'exempt_organization' },
  { label: 'Corporation', value: 'corporation' },
];

export const BookkeepingSoftwareOptions = [
  { label: 'Client Books', value: 'client_books' },
  { label: 'Quick Books', value: 'quick_books' },
  { label: 'Xero', value: 'xero' },
  { label: 'Wave', value: 'wave' },
  { label: 'Excel', value: 'excel' },
  { label: 'Other Software', value: 'other_software' },
];

export const FiscalYearStartOptions = [
  { label: 'January', value: 'january' },
  { label: 'February', value: 'february' },
  { label: 'March', value: 'march' },
  { label: 'April', value: 'april' },
  { label: 'May', value: 'may' },
  { label: 'June', value: 'june' },
  { label: 'July', value: 'july' },
  { label: 'August', value: 'august' },
  { label: 'September', value: 'september' },
  { label: 'October', value: 'october' },
  { label: 'November', value: 'november' },
  { label: 'December', value: 'december' },
];
export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('required').nullable(),
  ein: Yup.string().trim().nullable(),
  business_type: Yup.string().nullable().required('required'),
  formation_date: Yup.string().nullable(),
  specialization_id: Yup.string().nullable().required('required'),
  formation_state: Yup.string().nullable(),
  address: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  fiscal_year_start: Yup.string().nullable(),
  ownership: Yup.string().nullable(),
  business_owners: Yup.array().of(
    Yup.object().shape({
      user_id: Yup.string().nullable(),
      firstname: Yup.string().nullable().required('required'),
      lastname: Yup.string().nullable().required('required'),
      ssn: Yup.string().nullable(),
      ownership_percentage: Yup.number()
        .typeError('you must specify a number less than 100')
        .moreThan(0, 'Ownership should not be zero or less than zero')
        .lessThan(101, 'Ownership should not be more than 100')
        .required('required'),
      zipcode: Validators.zipCode,
    }),
  ),
  phone_number: Yup.string().trim().nullable(),
  zipcode: Validators.zipCode,
  bookkeeping_software: Yup.string().nullable(),
});
